import React from 'react'

type Props = {}

const NewsPage = (props: Props) => {
  return (
    <div>NewsPage</div>
  )
}

export default NewsPage